module.exports = __webpack_public_path__ + "img/ad.1d705279.png";